import React from "react";
import { useState } from "react";
import { useContext } from "react";
import { Link } from 'react-router-dom';

//import axios from 'axios';
import axios_api from "../Api";

import { API_URL, AUTH_TOKEN } from '../Context';
import SearchBar from "./common/SearchBar";


function Lab({username, organisation}){
  return(
    <tr>
      <td><Link className="" to={`/lab/` + username}>{username}</Link> </td>
    </tr>
  )
}


export default function LabList({}) {
  const [labs, setLabs] = useState([]);
  const [searchText, setSearchText] = useState('');
  const api_url = useContext(API_URL);  
  const token = useContext(AUTH_TOKEN);

  React.useEffect(() => {

      let labs = axios_api.get(api_url + '/users', {
        headers: {"Authorization": token},
      });
  
      labs.then(
        (result) => {
          let apiReturnedLabs = result.data;
          setLabs(apiReturnedLabs);
        },
        (error) => {
          console.log(error)
          setLabs([]);
        }
      );
  
  }, []);


  let rows = [];
  for(let i in labs) {
    if (labs[i].username.toLowerCase().indexOf(searchText.toLowerCase()) === -1) {
      //pass
    } else {
      rows.push(
        <Lab
          key={labs[i].username}
          //key={labs[i].id}
          //id={labs[i].id}
          username={labs[i].username}
          organization={labs[i].organization}
        />
      );
    }  
  }

  return(
    <>
      <div className="row">
       <h3 className="m-3">Лаборатории</h3>
      </div>
      <div className="m-3">
        <SearchBar
          key="SearchBar" 
          searchText={searchText} 
          onSearchtextChange={setSearchText} 
        />
      </div>
      <div className="row">
        <div className="col-4 m-3">
          <table className="table">
            <thead>
              <tr>
                <th>имя пользователя</th>      
              </tr>
            </thead>
            <tbody>
              {rows} 
            </tbody>
          </table>
        </div>
        <div className="col-2 m-3">
        </div>
      </div>      
    </>
  );
}
